export const RANK_NAMES = ['Бронза', 'Серебро', 'Золото', 'Платина', 'Алмаз'] as const;

export function RankEmblem({ rank }: { readonly rank?: number }) {
  if (rank !== undefined)
    return (
      <img
        className="rank-emblem"
        src={`/art/warm-ranks/star-rank-${rank}-v14.webp`}
        width={192}
        height={192}
        alt={`Эмблема ранга «${RANK_NAMES[rank - 1]}»`}
      />
    );
  return (
    <svg viewBox="0 0 120 140" width="100" height="116" role="img" aria-label="Эмблема ранга">
      <title>Эмблема ранга</title>
      <defs>
        <linearGradient id="rank-metal" x2="1" y2="1">
          <stop stopColor="#eef3ff" />
          <stop offset=".5" stopColor="#8799ba" />
          <stop offset="1" stopColor="#d2c8ff" />
        </linearGradient>
      </defs>
      <path d="M10 30 32 40 22 85 3 64Zm100 0L88 40l10 45 19-21Z" fill="#8799ba" />
      <path
        d="M60 5 100 28v62l-40 42-40-42V28Z"
        fill="#25252d"
        stroke="url(#rank-metal)"
        strokeWidth="5"
      />
      <path d="m60 20 27 16v48l-27 28-27-28V36Z" fill="#303039" stroke="#bbcae8" />
      <path d="m60 39 9 19 20 3-15 15 4 21-18-10-18 10 4-21-15-15 20-3Z" fill="url(#rank-metal)" />
    </svg>
  );
}
